import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Spinner } from 'react-bootstrap-v5';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllTestimonials } from '../../store/Testimonial/TestimonialThunks';

const Testimonial = () => {
  const dispatch = useDispatch();
  const { testimonialList, pagination } = useSelector((state) => state.Testimonials);

  const [page, setPage] = useState(1);
  const limit = 5; // Adjust limit as needed

  useEffect(() => {
    dispatch(fetchAllTestimonials({ page: 1, limit }));
  }, [dispatch]);

  const fetchMoreData = () => {
    const nextPage = page + 1;
    dispatch(fetchAllTestimonials({ page: nextPage, limit }));
    setPage(nextPage);
  };

  // const hasMore = testimonialList?.length < totalCount;

  return (
    <div>
      <Navbar />
      <div className="wpo-team-section section-padding">
        <div className="container">
          {testimonialList && (
            <InfiniteScroll
              dataLength={testimonialList.length}
              next={fetchMoreData}
              hasMore={testimonialList?.length < pagination?.total}

              loader={
                <div className="text-center mt-5">
                  <p>Lording....    </p>
                  <Spinner animation="border" color="#D4B0A5" />
                </div>
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b></b>
                </p>
              }
            >
              {testimonialList.map((item, index) => (
                <div key={index} className="testimonial-item mb-4 text-center">
                  <img
                    src={item?.image?.compressedUrl}
                    alt={`testimonial-${index}`}
                    className="img-fluid rounded"
                    // style={{ maxWidth: '300px', height: 'auto' }}
                  />
                  {/* You can add more details like name or message if available */}
                </div>
              ))}
            </InfiniteScroll>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Testimonial;
